import type { CSSProperties } from 'react';
import type { CluePayload } from '@guess/engine';
import type { ClueProps } from './ClueRenderer';
import s from './clue.module.scss';

type SwatchPayload = Extract<CluePayload, { kind: 'swatch' }>;

/**
 * La pastille de couleur.
 *
 * C'est le seul indice qui DISPARAIT : au palier suivant, le serveur envoie
 * `none` et la pastille n'est plus la. On ne montre donc jamais la valeur
 * hexadecimale — la lire, la recopier, et le mini-jeu n'existe plus.
 *
 * Le fond est volontairement neutre et large : une couleur se juge mal a cote
 * d'une autre, et le plateau sombre fausserait deja la perception.
 */
export function SwatchClue({ payload }: ClueProps<SwatchPayload>) {
  return (
    <div className={s.swatchStage}>
      <div
        className={s.swatch}
        style={{ '--hex': payload.hex } as CSSProperties}
        role="img"
        aria-label="Couleur a memoriser"
      />
      <p className={s.swatchHint}>Regarde bien. Elle va disparaitre.</p>
    </div>
  );
}
